import { render, staticRenderFns } from "./ConversionSettingsMeasurementState.vue?vue&type=template&id=e108d2da&scoped=true"
import script from "./ConversionSettingsMeasurementState.vue?vue&type=script&lang=ts"
export * from "./ConversionSettingsMeasurementState.vue?vue&type=script&lang=ts"
import style0 from "./ConversionSettingsMeasurementState.vue?vue&type=style&index=0&id=e108d2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e108d2da",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/conversion/conversion-settings-change-measurement-state.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2Fconversion%2FConversionSettingsMeasurementState.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports